import React, { useContext } from 'react';
import T from '@prisjakt/ui-translate';
import { AppContext } from '@prisjakt/ui-app-context';
import Breadcrumb from '@prisjakt/ui-breadcrumb';
import PropTypes from 'prop-types';
import EmailSent from '../components/email-sent';
import { getCurrentRef } from '../helpers';

const ConfirmPage = ({ email }) => {
  const { t, market } = useContext(AppContext);
  return (
    <EmailSent
      email={email}
      market={market}
      backTo={getCurrentRef()}
      title={t('account', 'confirm.title')}
      information={t('account', 'confirm.information')}
      checkEmailNotice={<T domain="account">confirm.email-notice.md</T>}
      breadcrumbComponent={
        <Breadcrumb
          homeText={t('common', 'breadcrumb.home')}
          path={[
            {
              pathName: 'confirm',
              name: t('account', 'confirm.title'),
              id: '0',
            },
          ]}
        />
      }
    />
  );
};

const { string, shape } = PropTypes;

ConfirmPage.propTypes = {
  email: string.isRequired,
  backTo: shape({
    url: string,
    name: string,
  }),
};

ConfirmPage.defaultProps = {
  backTo: undefined,
};

export default ConfirmPage;
